<template>
  <transition name="slide-fade">
    <div v-show='modelVisable' class="models">
      <mt-header class="area-picker-header" fixed title="地区选择">
        <mt-button slot="left" icon="back" @click="hideModel"></mt-button>
      </mt-header>
      <div class="content">
        <div class="items">
          <div class="items-header" v-if="level < 1">省份</div>
          <div class="items-body" v-if="level < 1">
            <div @click="chooseArea('全省', 'HN', 0)" :class="{'items-body-item-active': 'HN' === storedId}"
                 class="items-body-item ">全省




















            </div>
            <div class="clearfix"></div>
          </div>
          <div v-if="level < 1" class="bg-height"></div>
          <div class="items-header" v-if="level < 2">地市</div>
          <div class="items-body items-body-2" v-if="level < 2">
            <div v-for="(c,i) in eparchyList" :key='c.code_id' @click="chooseArea(c.name, c.code_id, 1)"
                 :class="{'items-body-item-active': c.code_id === storedId}" class="items-body-item">
              {{c.name | valueFromt}}




















            </div>
            <div class="clearfix"></div>
          </div>
          <div v-if="level < 2" class="bg-height"></div>
          <div class="items-header">区县</div>
          <div class="items-body items-body-2">
            <div v-for="(c,i) in cityList" :key='c.code_id' @click="chooseArea(c.name, c.code_id, 2)"
                 :class="{'items-body-item-active': c.code_id === storedId}" class="items-body-item">
              {{c.name | valueFromt}}




















            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div @click="reset" class="left">重置</div>
        <div @click="submit" class="right">确定</div>
      </div>
    </div>
  </transition>
</template>
<script>
  import {Indicator, Toast} from 'mint-ui'
  import {deepCopyObj} from "libs/common/common";
  export default {
    components: {
      Indicator,
      Toast
    },
    props: {
      // 是否展示 model
      showModel: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        modelVisable: false,
        firstRequest: true,
        provinceList: [],
        eparchyList: [],
        cityList: [],
        model: {name: "全省", areaId: "HN", floor: 0, parent: {name: "", pid: ""}},
        storedId: "HN",
        storedName: "全省",
        storedFloor: 0,
        storedParent: {name: "", pid: ""},
        level: 0,
        time: 1 // 下钻次数
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      storedModel () {
        return this.$store.state.meal.model;
      }
    },
    filters: {
      // 去掉数值前面的字母
      valueFromt: function (value) {
        if (!value) return "";
        if (value.includes("_")) {
          return value.slice(2);
        } else {
          return value;
        }
      }
    },
    watch: {
      showModel(value) {
        this.modelVisable = value;
      },
      storedModel (obj) {
        if (obj.floor === 1) {
          this.storedId = obj.areaId;
          this.storedFloor = 1;
          this.getData(() => {
            this.model.name = this.storedName = obj.name;
            this.model.areaId = this.storedId = obj.areaId;
            this.model.floor = this.storedFloor = obj.floor;
            this.model.parent.name = this.storedParent.name = obj.parent.name;
            this.model.parent.pid = this.storedParent.pid = obj.parent.pid;
          });
          return;
        }
        this.model.name = this.storedName = obj.name;
        this.model.areaId = this.storedId = obj.areaId;
        this.model.floor = this.storedFloor = obj.floor;
        this.model.parent.name = this.storedParent.name = obj.parent.name;
        this.model.parent.pid = this.storedParent.pid = obj.parent.pid;
      },
      userInfo(val) {
        let _this = this;
        let userInfo = val;
        _this.level = userInfo.level;
        let areaName = userInfo.area; // 当前默认选择区域
        if (_this.level === 0) {
          _this.getData();
        } else if (_this.level === 1) {
          _this.model.name = _this.storedName = areaName;
          _this.time = 0;
          _this.model.floor = _this.storedFloor = 1;
          let areaId = "0" + userInfo.areaId;
          _this.model.areaId = _this.storedId = areaId;
          _this.model.parent = _this.storedParent = {name: areaName, pid: areaId};
          _this.eparchyList.push({code_id: areaId, name: areaName});
          _this.getData();
        } else {
          _this.model.floor = _this.storedFloor = 2;
          _this.model.name = _this.storedName = areaName;
          _this.model.areaId = _this.storedId = userInfo.areaId;
          _this.cityList.push({code_id: userInfo.areaId, name: areaName});
          _this.model.parent = _this.storedParent = {name: "", pid: this.$route.query.eparchy};
          _this.$store.commit("SAVE_MEAL_FIRST_AREAS", {
            firstAreas: _this.cityList
          });
        }
        _this.$store.commit("SAVE_MEAL_MODEL", {
          model: deepCopyObj(_this.model)
        });
      },
      '$route.' (val) {
        let _this = this;
        let query = _this.$route.query;
        let promise = new Promise((resolve, reject) => {
          if (query.eparchy === "" && query.city === "") {
            _this.model.areaId = "HN";
            _this.model.name = "全省";
            _this.cityList = [];
            _this.time = 0; // 因为已经默认请求了市级数据,所以当前的下钻是0开始
            _this.model.floor = 0;
            resolve();
          } else if (query.eparchy !== "" && query.city === "") {
            let eparchy = _this.eparchyList.find((eparchy) => {
              return eparchy.code_id === query.eparchy;
            });
            _this.model.areaId = query.eparchy;
            _this.model.name = eparchy.name;
            _this.model.floor = 1;
            _this.model.parent = {name: eparchy.name, pid: query.eparchy};
            resolve();
          } else {
            if (_this.cityList.length === 0) {
              _this.$http.post(_this.$urls.getDrillDown, {
                area_id: query.eparchy
              }).then((res) => {
                _this.cityList = res.data.data;
                let city = _this.cityList.find((city) => {
                  return city.code_id === query.city;
                });
                _this.model.areaId = city.code_id;
                _this.model.floor = 2;
                _this.model.name = city.name;
                resolve();
              })
            } else {
              let city = _this.cityList.find((city) => {
                return city.code_id === query.city;
              });
              _this.model.areaId = city.code_id;
              _this.model.floor = 2;
              _this.model.name = city.name;
              resolve();
            }
          }
        });
        promise.then(() => {
          _this.$store.commit("SAVE_MEAL_MODEL", {
            model: deepCopyObj(_this.model)
          });
        })
      }
    },
    methods: {
      // 提交
      submit() {
        let _this = this;
        if (_this.model.areaId !== _this.storedId) {
          _this.model.name = _this.storedName;
          _this.model.areaId = _this.storedId;
          _this.model.floor = _this.storedFloor;
          _this.model.parent = _this.storedParent;
          this.$store.commit("SAVE_MEAL_MODEL", {
            model: deepCopyObj(_this.model)
          });
        }
        _this.$emit("hide", 3);
        _this.modelVisable = false;
      },
      // 重置
      reset() {
        let _this = this;
        if (_this.level === 0) {
          _this.storedId = "HN";
          _this.storedName = "全省";
          _this.cityList = [];
          _this.time = 0; // 因为已经默认请求了市级数据,所以当前的下钻是0开始
          _this.storedFloor = 0;
        } else if (_this.level === 1) {
          let eparchy = _this.eparchyList[0];
          let areaId = eparchy.code_id;
          let name = eparchy.name;
          _this.storedId = areaId;
          _this.storedName = name;
          _this.storedFloor = 1;
          _this.storedParent = {name: name, pid: areaId};
        }
      },
      // 关闭 model
      hideModel(type) {
        let _this = this;
        _this.modelVisable = false;
        _this.storedId = _this.model.areaId;
        _this.storedFloor = _this.model.floor;
        _this.storedName = _this.model.name;
        _this.storedParent = _this.model.parent;
        _this.$emit("hide", 3);
      },
      chooseArea(name, id, floor) {
        let _this = this;
        _this.storedId = id;
        _this.storedFloor = floor;
        _this.storedName = name;
        if (_this.level === 0 && _this.time === 0 && floor !== 2 && id !== "HN") {
          _this.storedParent = {pid: id, name: name};
          _this.getData()
        }
      },
      // 根据用户身份获取地区数据
      getData(func) {
        Indicator.open();
        let _this = this;
        _this.$http
          .post(_this.$urls.getDrillDown, {area_id: _this.storedId})
          .then(res => {
            Indicator.close();
            if (res.data.code === 200) {
              if (_this.level === 0 && _this.time === 1 && this.storedFloor === 0) {
                _this.eparchyList = res.data.data;
                _this.time--;
              } else if (_this.level === 0 && _this.time === 0 && this.storedFloor === 1) {
                _this.cityList = res.data.data;
//                _this.time = -1;
              } else if (_this.level === 1 && _this.time === 0) {
                _this.cityList = res.data.data;
                _this.time = -1;
              }

              if (_this.firstRequest) {

                let userInfo = _this.userInfo;
                let level = userInfo.level;
                let firstAreas = [];
                if (level === 0) {
                  firstAreas = _this.eparchyList;
                } else if (level === 1) {
                  firstAreas = _this.cityList;
                } else {
                  firstAreas.push({code_id: userInfo.areaId, name: userInfo.area});
                }
                _this.$store.commit("SAVE_MEAL_FIRST_AREAS", {
                  firstAreas: firstAreas
                });

                _this.firstRequest = false;
              }
            } else {
              Toast("地区数据请求出错");
            }
          }).then(() => {
          if (func) {
            func();
          }
        }).catch(error => {
          Indicator.close();
          console.error(error);
        });
      }
    },
    created() {
      console.log("初始化area-picker");
    }
  }
</script>
<style lang="less" scoped>
  .font-family-fn(@family) {
    font-family: @family;
  }

  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all 0.15s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .models {
    color: #2f2f2f;
    width: 100%;
    height: auto;
    z-index: 9999999;
    background: #fff;
    padding-bottom: 1rem;
    position: fixed;
    top: 0;
    bottom: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    .bg-height {
      height: 0.2rem;
      width: 100%;
      background-color: #f4f4f4;
    }
    .mint-header {
      background-color: #0384df;
      height: .89rem;
      .mint-button {
        padding-right: 0.3rem;

      }
    }
    .mint-popup-right {
      width: 100%;
      min-height: 100%;
      border-radius: 0;
    }
    .content {
      overflow: scroll;
      font-size: 0.3rem;
      min-height: 13rem;
      padding-top: .89rem;
      .items {
        // padding: 0.2rem 0;
        .items-header {
          padding: 0 0.3rem;
          height: 0.8rem;
          line-height: 0.8rem;
          text-align: left;
        }
        .items-body {
          margin-bottom: 0.2rem;
          padding: 0 0.3rem;
          // min-width: 4rem;
          .items-body-item {
            font-size: 0.26rem;
            text-align: center;
            width: 1.92rem;
            margin-top: 0.2rem;
            float: left;
            padding: 0.1rem 0.1rem;
            border: 0.02rem solid #eee;
            margin-right: 0.2rem;
          }
          .items-body-item:nth-child(3n) {
            margin-right: 0rem;
          }
          .items-body-item-active {
            background-color: #f4f4f4;
          }
        }
        .items-body {
          min-width: 4rem;
        }
      }
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      font-size: 0.3rem;
      height: 1rem;
      width: 100%;
      background: 0.02rem solid #eee;
      .left,
      .right {
        float: left;
        width: 50%;
        text-align: center;
        line-height: 1rem;
        background-color: #fff;
        border-top: 0.02rem solid #eee;
      }
      .right {
        color: #fff;
        background-color: #0384df;
        border-top: 0.02rem solid #0384df;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/app/setMeal/areaPicker.vue